// Use environment variables or fallback to the production URL
const SERVER_URL = process.env.REACT_APP_SERVER_URL || "https://auktion.hck.at";

export const API_BASE_URL = SERVER_URL;
export const SOCKET_URL = SERVER_URL;
